@use '../../styling/form-controls.scss' as *;

.LogGroup {
  position: relative;
  padding-left: 3em;

  .StepNumber {
    position: absolute;
    left: 0;
  }

  .LogItemList {
    box-sizing: border-box;
    overflow: auto;
    height: 100%;
    margin: 0;

    &,
    li {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    li {
      padding-bottom: 0.5em;
    }
  }
}
